import { Component, input } from '@angular/core';

@Component({
  selector: 'app-totals-display',
  template: ` <div class="flex flex-col items-center uppercase text-white">
    <div class="flex items-center">
      <div
        class="number text-[90px] font-normal leading-[108px] max-[1100px]:text-[70px] max-[1100px]:leading-[80px]"
      >
        {{ activeOrders() || 0 }}
      </div>
      <div
        class="pl-[15px] pt-[7px] text-[19px] font-bold leading-[22px] max-[1100px]:text-[16px] max-[1100px]:leading-[20px]"
      >
        Total Active
        <span
          class="mt-1 flex text-[40px] font-normal capitalize leading-[48px] max-[1100px]:text-[34px] max-[1100px]:leading-[40px]"
        >
          Orders
        </span>
      </div>
    </div>
    <div
      class="mt-1 text-[22px] font-bold leading-[21.6px] text-white max-[1100px]:text-[19px] max-[1100px]:leading-[21px]"
    >
      Spanning {{ activeLocations() || 0 }} locations
    </div>
  </div>`,
})
export class TotalsDisplayComponent {
  readonly activeLocations = input<number>();

  readonly activeOrders = input<number>();
}
